<div class="user-in-main" appSpin [spinnerConfig]='spinnerConfig()'>
    <!-- <div *ngIf="isSsoSignupInProgress" class="w-100 text-center">
        <div class="spinner" id="loading-bar-spinner" title="please wait ...">
            <div class="spinner-icon"></div>
        </div>
    </div> -->

    <div class="left-block">
        <button title="Countable.co" mat-button mat-stroked-button color="dark"
                class="button-default back-to-website-btn"
                (click)="siteNavigate()">
                <span class="flexbox-row gap-8">
                    <i class="fa-regular fa-house"></i>
                    <span class="button-label">Back To Website</span>
                </span>
        </button>
        <ng-image-slider class="slider" #nav [images]="imgCollection" [infinite]="true" [autoSlide]="2"
                         [animationSpeed]="0.8" slideImage="1" [imageSize]="{width: '100%', height: '100%'}"
                         [imagePopup]="false"></ng-image-slider>
        <a class="support-link text-white" href="mailto:support@countable.co"
           title="support@countable.co">support&#64;countable.co</a>
    </div>

    <div class="right-block" >
        <div class="content-block br-12 bg-white gap-24">
            <div class="brand align-self-center" [ngClass]="{'signup-success-container':isRegistrationFinished}">
                <img src="/assets/images/global/brand-primary.svg" alt="Countable"/>
            </div>
            <ng-container *ngIf="!isRegistrationFinished && !isSsoFirmExist">
                <h3 class="title align-self-center">Create your account</h3>
                <form [formGroup]="signupFrom" (ngSubmit)="signup()">
                    <div class="form-group">
                        <mat-form-field floatLabel="always" class="fixed-label w-100">
                            <mat-label>Select a country</mat-label>
                            <mat-select matNativeControl disableOptionCentering panelClass="countryDropdown"
                                        formControlName="country" placeholder="Select a country">
                                <mat-option [value]="country.id" *ngFor="let country of countries">
                                    {{country.printableName}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <div class="field-inline">
                            <mat-form-field floatLabel="always" class="fixed-label">
                                <mat-label>First Name</mat-label>
                                <input matInput class="firstNameCls" formControlName="firstname"
                                       (input)="onlyChars($event,'fn')" maxlength="50" placeholder="First Name"
                                       required>
                            </mat-form-field>
                            <mat-form-field floatLabel="always" class="fixed-label">
                                <mat-label>Last Name</mat-label>
                                <input matInput formControlName="lastname" (input)="onlyChars($event,'ln')"
                                       maxlength="50" placeholder="Last Name" required>
                            </mat-form-field>
                        </div>
                        <mat-form-field floatLabel="always" class="fixed-label w-100">
                            <mat-label>Firm Name</mat-label>
                            <input matInput formControlName="firm" maxlength="155"
                                   placeholder="Firm Name" required>
                        </mat-form-field>
                        <mat-form-field floatLabel="always" class="fixed-label w-100">
                            <mat-label>Firm size (No. of users)</mat-label>
                            <input matInput (input)="onlyNumeric($event,'size')" formControlName="firmSize"
                                   maxlength="14" placeholder="Firm size (No. of users)" required>
                        </mat-form-field>
                        <mat-form-field floatLabel="always" class="fixed-label w-100">
                            <mat-label>E-mail</mat-label>
                            <input matInput formControlName="email" maxlength="100"
                                   placeholder="E-mail" required>
                        </mat-form-field>
                        <mat-form-field floatLabel="always" class="fixed-label w-100">
                            <mat-label>Phone number</mat-label>
                            <input matInput (input)="handlePhone($event,'cell')" formControlName="phone" minlength="14"
                                   placeholder="Phone number" maxlength="14">
                        </mat-form-field>
                        <div class="ng-form-field input-none w-100 required">
                            <label>How did you hear about us?</label>
                            <ng-select class="team-dropdown access-typohead how-hear" [items]="referenceData"
                                       bindValue="hash" [virtualScroll]="true" [clearable]="false"
                                       (change)="enableInputs('referenceId2')" bindLabel="name"
                                       formControlName="referenceId1">
                            </ng-select>
                            <span class="select-reference-placeholder"
                            *ngIf="!signupFrom.controls['referenceId1'].value || signupFrom.controls['referenceId1'].value.length === 0">
                                How did you hear about us?
                            </span>
                        </div>

                        <div class="ng-form-field input-none w-100 required" *ngIf="signupFrom.get('referenceId1').value && signupFrom.get('referenceId1').value !=='a8b34cca-2fc4-1' && subReferenceData?.length > 0 ">
                            <label>Select from {{ referenceName1 }}</label>
                            <ng-select class="team-dropdown access-typohead how-hear" [items]="subReferenceData"
                                       bindValue="hash" [virtualScroll]="true" [clearable]="false"
                                       (change)="enableInputs('referenceId3')" bindLabel="name"
                                       formControlName="referenceId2">
                            </ng-select>
                            <span class="select-reference-placeholder"
                            *ngIf="!signupFrom.controls['referenceId2'].value || signupFrom.controls['referenceId2'].value.length === 0">
                                Select from {{ referenceName1 }}
                            </span>
                        </div>

                        <div class="ng-form-field input-none w-100 required" *ngIf="signupFrom.get('referenceId2').value && nextSubReferenceData?.length > 0 ">
                            <label>Select from {{ referenceName2 }}</label>
                            <ng-select class="team-dropdown access-typohead how-hear" [items]="nextSubReferenceData"
                                       bindValue="hash" [virtualScroll]="true" [clearable]="false"
                                       (change)="enableInputs('reference')" bindLabel="name"
                                       formControlName="referenceId3">
                            </ng-select>
                            <span class="select-reference-placeholder"
                            *ngIf="!signupFrom.controls['referenceId3'].value || signupFrom.controls['referenceId3'].value.length === 0">
                                  Select from {{ referenceName2 }}
                            </span>
                        </div>
                        <!-- Who referred Text box -->
                        <mat-form-field floatLabel="always" class="fixed-label w-100"
                                        *ngIf="
                                        signupFrom.get('referenceId1').value ==='a8b34cca-2fc4-1' ||
                                        signupFrom.get('referenceId3').value ==='e99815fc-2fd' ||
                                        signupFrom.get('referenceId3').value ==='1777e57d-2fd'">
                            <mat-label>Please Specify</mat-label>
                            <input matInput formControlName="reference" maxlength="100"
                                   (input)="enableInputs('accept');" placeholder="Please Specify"
                                   [readonly]="cameFromReferral" required>
                            <!-- <span class="input-placeholder"
                                  [hidden]="signupFrom.controls['reference'].value.length > 0">{{getPlaceholderForReferenceInput(signupFrom.get('referenceId').value)}}</span> -->
                        </mat-form-field>
                    </div>

                    <div class="acceptance d-flex flex-nowrap flex-row mt-20">
                        <mat-checkbox class="accept-check-box" formControlName="accept" required></mat-checkbox>
                        <p class="fs-14 text-gray-7 fw-medium ms-2">I agree to the
                            <button class="text-link" title="Terms of Use"
                               (click)="openTermsPrivacyDialog('terms-of-Use')">Terms of Use</button>
                            &
                            <button class="text-link"
                               (click)="openTermsPrivacyDialog('privacy-policy')">Privacy Policy</button>
                        </p>
                    </div>

                    <button mat-button mat-flat-button class="button-large mt-4 signup-analytics" color="primary" type="submit"
                            [disabled]="signupFrom.invalid">
                        <div *ngIf="isSsoSignup">Finish Sign Up with {{ ssoProvider }}</div>
                        <div *ngIf="!isSsoSignup" class="signup-analytics-text" >Sign Up Now</div>
                    </button>

                    <!-- SSO -->
                    <div class="seprator">
                        <span class="seprator-content">
                            Or continue with
                        </span>
                    </div>

                    <div class="flexbox-row flex-wrap gap-16">
                        <button mat-button mat-stroked-button color="dark" class="button-default other-log-button" (click)="signupWithOAuthKickOff('xero')">
                            <img src="./assets/images/ui-uplift-icons/logos/xero-circle-logo.svg" alt="xero">
                            Sign in with Xero
                        </button>
                        <button mat-button mat-stroked-button color="dark" class="button-default other-log-button" (click)="signupWithOAuthKickOff('sage')">
                            <img src="./assets/images/ui-uplift-icons/logos/sage-small-logo.svg" alt="Sage">
                            Sign in with Sage
                        </button>
                        <div class="button-default mat-button mat-stroked-button p-0 other-log-button overflow-hidden" #googleSSO></div>
                        <button mat-button mat-stroked-button class="button-default qb-button other-log-button" (click)="signupWithOAuthKickOff('quickbooks')">
                            Sign in with Intuit
                        </button>
                    </div>

                    <p class="get-account text-center text-gray-5 mt-32">
                        Already have an account?
                        <a class="text-link" routerLink="/login" title="Login">Login</a>
                    </p>
                </form>
            </ng-container>

            <!-- Success message -->
            <ng-container *ngIf="isRegistrationFinished">
                <div class="text-center" *ngIf="isSsoSignup">
                    <span class="icon-outer mb-lg-4 mb-3 mx-auto bg-success-1">
                        <svg width="20" height="17.5" viewBox="0 0 17 15" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M14.7953 0.853403L5.24867 10.0667L2.71534 7.36007C2.24867 6.92007 1.51534 6.8934 0.982005 7.26674C0.462005 7.6534 0.315338 8.3334 0.635338 8.88007L3.63534 13.7601C3.92867 14.2134 4.43534 14.4934 5.00867 14.4934C5.55534 14.4934 6.07534 14.2134 6.36867 13.7601C6.84867 13.1334 16.0087 2.2134 16.0087 2.2134C17.2087 0.986737 15.7553 -0.093263 14.7953 0.84007V0.853403Z"
                                  fill="#37A77C"/>
                        </svg>
                    </span>
                    <h4 class="title mb-lg-4 mb-3 text-center">Thank you for choosing Countable.</h4>
                    <div class="mb-32">
                        <p>You can now access your account using our {{ ssoProvider | titlecase }} Single Sign-On
                            service.
                            To get started, simply click on the "Login now" button and select {{ ssoProvider | titlecase
                            }} to access your account.</p>
                        <p>We also send an activation email to</p>
                        <h5 [title]="signupFrom.controls['email'].value">{{signupFrom.controls['email'].value}}</h5>
                        <p> which will allow you to set your Countable password in case you ever wanted to login without
                            SSO</p>
                    </div>
                    <button color="primary" mat-button mat-flat-button class="button-large w-100 mb-lg-4 mb-3"
                            [routerLink]="['/login']">Login Now
                    </button>
                </div>
                <div class="text-center" *ngIf="!isSsoSignup">
                    <span class="icon-outer mb-lg-4 mb-3 mx-auto bg-success-1">
                        <svg width="20" height="17.5" viewBox="0 0 17 15" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M14.7953 0.853403L5.24867 10.0667L2.71534 7.36007C2.24867 6.92007 1.51534 6.8934 0.982005 7.26674C0.462005 7.6534 0.315338 8.3334 0.635338 8.88007L3.63534 13.7601C3.92867 14.2134 4.43534 14.4934 5.00867 14.4934C5.55534 14.4934 6.07534 14.2134 6.36867 13.7601C6.84867 13.1334 16.0087 2.2134 16.0087 2.2134C17.2087 0.986737 15.7553 -0.093263 14.7953 0.84007V0.853403Z"
                                  fill="#37A77C"/>
                        </svg>
                    </span>
                    <h4 class="title" class="title mb-lg-4 mb-3 text-center">Thank you for choosing Countable.</h4>
                    <div class="mb-32">
                        <p>An email has been sent to</p>
                        <h5 [title]="signupFrom.controls['email'].value">{{signupFrom.controls['email'].value}}</h5>
                        <p>for verification</p>
                    </div>
                    <button color="primary" mat-button mat-flat-button class="button-large w-100 mb-lg-4 mb-3"
                            [routerLink]="['/login']">Login Now
                    </button>
                </div>
            </ng-container>
        </div>
    </div>
</div>
